export const tellAFriendConstant = {
    REQUEST: 'TELL_A_FRIEND_REQUEST',
    RESPONSE: 'TELL_A_FRIEND_RESPONSE',
};
